module.exports = __webpack_public_path__ + "static/media/heart-circle.4347e6be.svg";